import { OwnerInfoFields } from '@/components/Chat/OwnerInfoFields'
import type { OwnerInfoForm } from '@/components/Chat/useOwnerInfoForm'
import { FieldError } from '@/components/ui/field'
import type { FillApplicationState } from '@/models/fillApplication'
import type { BusinessOwner } from '@/models/user'
import { ChangeOwnerPick } from './ChangeOwnerPick'
import { EmailRecipientsLine } from './EmailRecipientsLine'
import { FillSectionCard } from './FillSectionCard'
import { OwnerSuggestions } from './OwnerSuggestions'
import { PickOwnerPanel } from './PickOwnerPanel'

interface BusinessOwnerSectionProps {
  orgId: string
  state: FillApplicationState
  /** The owner linked to the application, if any. */
  owner: BusinessOwner | null | undefined
  form: OwnerInfoForm
}

export function BusinessOwnerSection({ orgId, state, owner, form }: BusinessOwnerSectionProps) {
  const nobody = !owner && !state.emailRecipients.priceAndLink

  return (
    <FillSectionCard title="Business owner">
      {state.ownerPickNeeded ? (
        <PickOwnerPanel orgId={orgId} owners={state.owners} />
      ) : (
        <>
          {nobody ? (
            <p className="text-ink-500 text-sm">
              No business owner yet. Saving adds them; nothing is sent to them yet.
            </p>
          ) : (
            <ChangeOwnerPick orgId={orgId} owners={state.owners} currentOwnerId={owner?.id} />
          )}
          <OwnerInfoFields form={form.form} columns={2} idPrefix="fill-oi" />
          <FieldError>{form.form.formState.errors.root?.server.message}</FieldError>
          <EmailRecipientsLine recipients={state.emailRecipients} priceEmails={state.priceEmails} />
        </>
      )}
      <OwnerSuggestions orgId={orgId} owner={owner} suggestions={state.ownerSuggestions} />
    </FillSectionCard>
  )
}
